import React from "react";

import { ButtonWithIcon } from "../ButtonWithIcon";
import { ErrorHeader } from "../HeaderBar";
import LexWorkplaceLogo from "../../svg/LexWorkplaceLogo";
import "./FullPageError.css";
import { IconLogout, IconProgressHelp } from "@tabler/icons-react";
import { LexWorkplaceRefreshIcon } from "../LexWorkplaceIcons";

const FullPageError = ({ logOut }) => {
	const handleReload = () => {
		window.location.reload();
	};

	return (
		<div className="App">
			<ErrorHeader />
			<div className="full-page-error">
				<div>
					<div className="error-content">
						<div className="error-logo">
							<LexWorkplaceLogo />
						</div>
						<div className="error-text-block">
							<div className="error-title">CRITICAL ERROR</div>
							<div className="error-text">
								LexWorkplace could not be loaded
							</div>
							<div className="error-subtext">
								Please reload your page or contact Uptime Legal
								support
							</div>
						</div>
					</div>
					<div className="error-buttons">
						<ButtonWithIcon
							handler={handleReload}
							buttonText="Reload Page"
							iconComponent={<LexWorkplaceRefreshIcon />}
						/>
						<a
							href="https://help.lexworkplace.com/"
							target="_blank"
							rel="noopener noreferrer"
							className="error-button-link"
						>
							<ButtonWithIcon
								buttonText="Contact Support"
								iconComponent={
									<IconProgressHelp
										size={20}
										style={{ verticalAlign: "middle" }}
									/>
								}
							/>
						</a>
						<ButtonWithIcon
							handler={logOut}
							buttonText="Log Out"
							iconComponent={
								<IconLogout
									size={20}
									style={{ verticalAlign: "middle" }}
								/>
							}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FullPageError;
